/**
 * Canonical semantic colors for revenue and activity metric cards.
 * Reuse these tones so the same metric has the same visual identity everywhere.
 */
export type MetricTone = {
  tone: string;
  accent: string;
  valueClassName: string;
};

/** Card title — e.g. "Semester Sales", "Win Rate". */
export const METRIC_CARD_HEADING_CLASS =
  "truncate text-[12px] font-semibold tracking-wide text-foreground";

/** Secondary copy inside the card — e.g. "With Deal", stage legend, hints. */
export const METRIC_CARD_SECONDARY_CLASS = "text-metric-label";

export const METRIC_TONE = {
  accountValue: {
    tone: "bg-metric-account-value-background text-metric-account-value",
    accent: "border-l-metric-account-value",
    valueClassName: "text-metric-account-value",
  },
  semesterSales: {
    tone: "bg-metric-semester-sales-background text-metric-semester-sales",
    accent: "border-l-metric-semester-sales",
    valueClassName: "text-metric-semester-sales",
  },
  forecastedSales: {
    tone: "bg-metric-forecasted-sales-background text-metric-forecasted-sales",
    accent: "border-l-metric-forecasted-sales",
    valueClassName: "text-metric-forecasted-sales",
  },
  forecastedPace: {
    tone: "bg-metric-forecasted-pace-background text-metric-forecasted-pace",
    accent: "border-l-metric-forecasted-pace",
    valueClassName: "text-metric-forecasted-pace",
  },
  latestActivity: {
    tone: "bg-metric-latest-activity-background text-metric-latest-activity",
    accent: "border-l-metric-latest-activity",
    valueClassName: "text-metric-latest-activity",
  },
} as const satisfies Record<string, MetricTone>;

/**
 * Identity / Information cards (account header, deal account summary, etc.).
 * One left-border color app-wide — same token as Account Value.
 */
export const INFO_CARD = {
  shell: "rounded-2xl border-metric-card border-l-4 shadow-sm",
  accent: METRIC_TONE.accountValue.accent,
} as const;
